
import { EventDetails } from '@/api/Helpers'
import { currentMembership, isCurrentMember, membershipOnDate } from '@/state/Membership'
import { Moment } from 'moment-timezone/moment-timezone'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({ name: 'RenewMembershipMessage' })
export default class extends Vue {
  @Prop({ required: true })
  event: EventDetails

  @Prop({ required: true })
  dateToCheck: Moment

  get eventHasMembersTickets(): boolean {
    return (
      this.event.hidden_type === 'public_member_only' ||
      this.event.ticketGroups.some((group) => group.hidden_type === 'public_member_only')
    )
  }

  get membershipExpiredByDate(): boolean {
    return isCurrentMember() && membershipOnDate(this.dateToCheck) === undefined
  }

  get getMembershipRenewalMessage(): string | null {
    if (this.eventHasMembersTickets && this.membershipExpiredByDate) {
      const current = currentMembership()
      const dateFormat = this.$t('dateFormat.medium') as string
      const ticketDate = this.dateToCheck.format(dateFormat)
      if (current) {
        const expiryDate = current.validTo.format(dateFormat)
        return this.expiresInMessage(expiryDate, ticketDate)
      } else {
        return this.expiredMessage(ticketDate)
      }
    } else {
      return null
    }
  }

  expiresInMessage(expiryDate: string, ticketDate: string) {
    return this.$t('renewMembershipMessage.expiresIn', {
      expiryDate,
      ticketDate,
    }) as string
  }

  expiredMessage(ticketDate: string) {
    return this.$t('renewMembershipMessage.expired', {
      ticketDate,
    }) as string
  }
}
